import DashboardTemplateItem from 'pages/Dashboards/DashboardTemplates/dashboardTemplateItem/dashboardTemplateItem';
import { Grid } from '@mui/material';
import { IDashboardTemplateItem } from 'pages/Dashboards/interfaces';
import DashboardListingHeader from 'pages/Dashboards/DashboardListing/Header/Header';
import { getReports } from 'api/reporting';
import { useQuery } from 'react-query';
import { QUERY_KEYS } from 'api/constants';
import { useEffect } from 'react';
import WithLoader from 'pages/Dashboards/Widgets/withLoader';
const data = [
  {
    id: 1,
    image:
      'https://fastly.picsum.photos/id/9/5000/3269.jpg?hmac=cZKbaLeduq7rNB8X-bigYO8bvPIWtT-mh8GRXtU3vPc', // Replace with actual image URL
    heading: 'Task Dashboard',
    subTitle:
      'Non dictum mauris. Nulla at tellus sagittis, viverra est a, bibendum.',
    color: '#E0F2F1',
  },
  {
    id: 2,
    image: 'https://placekitten.com/100/100',
    heading: 'Template Submissions Dashboard',
    subTitle:
      'Malesuada nunc vel risus commodo viverra maecenas accumsan lacus.',
    color: '#EDE7F6',
  },
  {
    id: 3,
    image: 'https://placekitten.com/100/100',
    heading: 'Location Dashboard',
    subTitle:
      'Facilisis mauris sit amet massa vitae tortor condimentum. Pulvinar etiam.',
    color: '#E1F5FE',
  },
  {
    id: 4,
    image: 'https://placekitten.com/100/100',
    heading: 'Score Dashboard',
    subTitle:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do.',
    color: '#FEEBEE',
  },
];

function DashboardTemplates() {
  const dashboardTemplatesQuery = useQuery(
    [QUERY_KEYS.GET_DASHBOARD_TEMPLATES],
    getReports,
    { enabled: false },
  );
  useEffect(() => {
    dashboardTemplatesQuery.refetch();
  }, []);

  return (
    <>
      <WithLoader isLoading={dashboardTemplatesQuery.isFetching}>
        <Grid container spacing={3}>
          {dashboardTemplatesQuery?.data?.map(
            (item: IDashboardTemplateItem, i) => {
              return (
                <DashboardTemplateItem key={item.id} item={item} index={i} />
              );
            },
          )}
        </Grid>
      </WithLoader>
    </>
  );
}

export default DashboardTemplates;
